import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  InvoiceArrivalRootParamList,
  ValidSetupRootParamList,
} from "../../../../types";
import {
  RootDrawerToggle,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { InvoiceArrivalsLandingScreen } from "../InvoiceArrivalsLandingScreen";
import { EditInvoiceArrivalRootScreen } from "../EditInvoiceArrivalRootScreen";
import { CreateInvoiceArrivalRootScreen } from "../CreateInvoiceArrivalRootScreen";
import { ViewInvoiceArrivalRootScreen } from "../ViewInvoiceArrivalRootScreen";
import { InvoiceArrivalFilterValues } from "../../types";
import { useListFilter } from "../../../../utilities/list-filter";
import { ListFilterProvider } from "../../../../utilities/list-filter/use-list-filter-context";
import { InvoiceArrivalFilterRootScreen } from "../InvoiceArrivalFilterRootScreen";

export type InvoiceArrivalsRootScreenProps = StackScreenProps<
  ValidSetupRootParamList,
  "InvoiceArrivalsRootScreen"
>;

export const InvoiceArrivalsRootScreen = ({
  navigation,
}: InvoiceArrivalsRootScreenProps) => {
  const Drawer = createStackHeaderNavigator<InvoiceArrivalRootParamList>();

  const filterContext = useListFilter<InvoiceArrivalFilterValues>({
    defaultValues: {
      supplierId: [],
      locationId: [],
      productId: [],
    },
  });

  return (
    <ListFilterProvider {...filterContext}>
      <Drawer.Navigator
        screenOptions={{
          animationEnabled: true,
          headerLeft: () => <RootDrawerToggle />,
          title: "",
        }}
      >
        <Drawer.Group>
          <Drawer.Screen
            name="InvoiceArrivalsLandingScreen"
            component={InvoiceArrivalsLandingScreen}
          />
        </Drawer.Group>
        <Drawer.Group
          screenOptions={{
            headerMode: "float",
            headerShown: false,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <Drawer.Screen
            name="EditInvoiceArrivalRootScreen"
            component={EditInvoiceArrivalRootScreen}
          />
          <Drawer.Screen
            name="ViewInvoiceArrivalRootScreen"
            component={ViewInvoiceArrivalRootScreen}
          />
        </Drawer.Group>
        <Drawer.Group
          screenOptions={{
            headerShown: false,
            presentation: "modal",
          }}
        >
          <Drawer.Screen
            name="CreateInvoiceArrivalRootScreen"
            component={CreateInvoiceArrivalRootScreen}
          />
        </Drawer.Group>
        <Drawer.Group
          screenOptions={{
            headerShown: false,
            presentation: "modal",
          }}
        >
          <Drawer.Screen
            name="InvoiceArrivalFilterRootScreen"
            component={InvoiceArrivalFilterRootScreen}
          />
        </Drawer.Group>
      </Drawer.Navigator>
    </ListFilterProvider>
  );
};
